// extracted by mini-css-extract-plugin
export default {"HTMLWrapper":"HTMLWrapper_HTMLWrapper__Yjc3Y","bpk-no-touch-support":"HTMLWrapper_bpk-no-touch-support__NmYyY"};